function assignedAtMs(device) {
  const value = device.assigned_at || device.createdAt;
  const time = value ? new Date(value).getTime() : 0;
  return Number.isNaN(time) ? 0 : time;
}

export function pickLastAssignedDealerBranding(devices) {
  if (!Array.isArray(devices) || devices.length === 0) {
    return null;
  }

  const withDealer = devices.filter((device) => device.dealer_id);
  if (withDealer.length === 0) {
    return null;
  }

  const lastAssigned = [...withDealer].sort((a, b) => {
    const byDate = assignedAtMs(b) - assignedAtMs(a);
    if (byDate !== 0) {
      return byDate;
    }
    return Number(b.id || 0) - Number(a.id || 0);
  })[0];

  const logoPath = lastAssigned.dealer_logo_path;
  if (!logoPath) {
    return null;
  }

  return {
    logoPath,
    companyName: String(lastAssigned.company_name || "").trim(),
  };
}

export function dealerLogoUrl(logoPath) {
  if (!logoPath) {
    return "";
  }
  if (/^(https?:\/\/|data:)/i.test(logoPath)) {
    return logoPath;
  }

  const base = (process.env.REACT_APP_BASE_URL || "").replace(/\/$/, "");
  const path = logoPath.startsWith("/") ? logoPath : `/${logoPath}`;
  return `${base}${path}`;
}

export function buildDealerRequest(fields, logoFile) {
  const payload = {};
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      payload[key] = value;
    }
  });

  if (!logoFile) {
    return payload;
  }

  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append("logo", logoFile);
  return formData;
}
